var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"com-unit"},[_c('span',{staticClass:"txt"},[_vm._v("单位"+_vm._s(_vm.num))]),_c('i',{staticClass:"el-icon-star-on star"})])}
var staticRenderFns = []

export { render, staticRenderFns }